import React from 'react'
import { MdContentCopy } from 'react-icons/md'
import { Button } from '~/components'
import { Copy } from './style'

export default function PaymentButton({ item }) {
    if (!item.paymentLink) {
        return null
    }

    return (
        <>
            <Button
                isRequesting={item.isGenerating || false}
                className="!w-full md:!w-48"
                onClick={() => window.open(item.paymentLink)}
            >
                Boleto bancário
            </Button>
            {item.linhaDigitavel && (
                <Copy
                    text={item.linhaDigitavel}
                    onCopy={() => alert('Linha digitável copiada com sucesso!')}
                >
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 2,
                        }}
                    >
                        <MdContentCopy />
                        <div>Copiar linha digitável do boleto</div>
                    </div>
                </Copy>
            )}
        </>
    )
}
